import { render, staticRenderFns } from "./ModelloEmailComponent.vue?vue&type=template&id=399fd8e4&"
import script from "./ModelloEmailComponent.vue?vue&type=script&lang=js&"
export * from "./ModelloEmailComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModelloEmailComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports